import { apiHelper } from '../utils/apiHelper';

const API_URL = `${process.env.REACT_APP_API_URL}/api/admin/country`;

const headers = {
  "Content-Type": "multipart/form-data",
  "Accept": "application/json"
};

export const fetchCountries = (payload) => apiHelper(API_URL, 'GET', payload);
export const createCountry = (payload) => apiHelper(API_URL, 'POST', payload, headers);
export const fetchCountry = (countryId) => apiHelper(`${API_URL}/${countryId}`, 'GET');
export const modifyCountry = (payload) => apiHelper(`${API_URL}/${payload.get('id')}`, 'POST', payload, headers);
export const deleteCountryApi = (countryId) => apiHelper(`${API_URL}/${countryId}`, 'DELETE');
export const changeStatus = (countryId) => apiHelper(`${API_URL}/change-status/${countryId}`, 'POST');

